export const selectSingleRestaurantModalTranslationEN = {
  SelectSingleRestaurantModal: {
    selection: 'Select',
  },
};
